import React from "react";

interface RatingDisplayProps {
  rating?: number;
  reviewCount?: number;
  variant?: "light" | "dark";
}

const RatingDisplay: React.FC<RatingDisplayProps> = ({
  rating = 4.9,
  reviewCount = 169,
  variant = "light",
}) => {
  const textColor = variant === "dark" ? "text-white" : "text-gray-900";
  const mutedTextColor = variant === "dark" ? "text-gray-200" : "text-gray-600";

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center space-x-1">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 text-yellow-400`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
      <div className="text-center text-sm">
        <span className={`font-bold ${textColor}`}>{rating}</span>
        <span className={mutedTextColor}> / 5 based on </span>
        <span className={textColor}>{reviewCount} reviews</span>
      </div>
      <div className="flex items-center justify-center space-x-4 text-sm">
        <div className={`flex items-center ${mutedTextColor}`}>
          <svg
            className="w-4 h-4 mr-1.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>100% Satisfaction Guarantee</span>
        </div>
        <div className={`flex items-center ${mutedTextColor}`}>
          <svg
            className="w-4 h-4 mr-1.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          <span>Secure Payment</span>
        </div>
      </div>
    </div>
  );
};

export default RatingDisplay;
